import React, { Component } from 'react';
import { Table, Row, } from 'antd';
import { inject, observer } from "mobx-react";
import TableText from "@/components/table/TableText";
import { toJS } from 'mobx';
const totalIndex = [];

@inject('store')
@observer
class index extends Component {

    onChange = (name, value, i) => {
        let { roomData, dayData, foodData } = this.props.store.dailyMonth;
        let data = [...toJS(roomData)];
        data[i][name] = value;
        this.props.store.dailyMonth.onChange({
            roomData: data, foodData, dayData
        });
    }

    render() {
        const { roomData, loading } = this.props.store.dailyMonth;
        const inputIndex = [0, 1, 2, 6, 7];
        const columns = [
            {
                title: <span>Rooms<br /> 客房</span>,
                dataIndex: 'name',
                key: 'name',
                align: "center",
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex,

                    };

                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Today<br /> 今日实际</span>,
                dataIndex: 'actual',
                key: 'actual',
                align: "center",
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "actual", onChange: this.onChange, totalIndex,
                        compared: {
                            title: ['Today<br /> 今日实际'],
                            record,
                            sqlName: "m_daily_month"
                        }
                    };
                    if (inputIndex.includes(index)) props.type = "number";
                    if ([3, 8].includes(index)) props.type = "percent";
                    return <TableText data={{ ...props }} />
                }
            }, {
                title: <span>Last Year <br /> 去年当日</span>,
                dataIndex: 'last',
                key: 'last',
                align: "center",
                render: (text, record, index) => {
                    const props = {
                        text, index, type: 'number', name: "last", onChange: this.onChange, totalIndex,
                        compared: {
                            title: ['Last Year <br /> 去年当日'],
                            record,
                            sqlName: "m_daily_month"
                        }
                    };
                    if (inputIndex.includes(index)) props.type = "number";
                    if ([3, 8].includes(index)) props.type = "percent";
                    return <TableText data={{ ...props }} />
                }
            }
        ]

        return (
            <div className="table7_1_1 ">
                <Row className="title" id="table4_1_1" >

                    <Table
                        columns={columns}
                        dataSource={toJS(roomData)}
                        size="middle"
                        bordered
                        pagination={false}
                        loading={loading}
                        className="content"
                        rowKey={(record, index) => index}
                    />
                </Row>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/daily/1.1/Rooms/index.js